import Vue from 'vue'
import Vuex from 'vuex'
import userStore from './modules/userStore'
import appStore from './modules/appStore'
import accountsStore from './modules/accountsStore'
import administratorStore from './modules/administratorStore'
import assetStore from './modules/assetStore'
import clusterStore from './modules/clusterStore'
import contractStore from './modules/contractStore'
import countryStore from './modules/countryStore'
import investorStore from './modules/investorStore'
import mediaStore from './modules/mediaStore'
import planStore from './modules/planStore'
import regionStore from './modules/regionStore'
import transactionStore from './modules/transactionStore'
import projectStore from './modules/projectStore'
import componentTypeStore from './modules/componentTypeStore'
import componentStore from './modules/componentStore'
import componentTransactionStore from './modules/componentTransactionStore'
import projectFinancialsStore from './modules/projectFinancialsStore'
import projectRatingStore from './modules/projectRatingStore'
import currencyStore from './modules/currencyStore'
import newsStore from './modules/newsStore'
import projectValuationStore from './modules/projectValuationStore'
import planReportStore from './modules/planReportStore'
import transactionRequestStore from './modules/transactionRequestStore'
import investorReportStore from './modules/investorReportStore'

Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    state: {
        count: 0
    },
    modules: {
        appStore,
        userStore,
        accountsStore,
        administratorStore,
        assetStore,
        clusterStore,
        contractStore,
        countryStore,
        investorStore,
        mediaStore,
        planStore,
        regionStore,
        transactionStore,
        projectStore,
        componentTypeStore,
        componentStore,
        componentTransactionStore,
        projectFinancialsStore,
        projectRatingStore,
        currencyStore,
        newsStore,
        projectValuationStore,
        planReportStore,
        transactionRequestStore,
        investorReportStore

    },
    strict: debug
})



// WEBPACK FOOTER //
// ./resources/js/store/index.js